export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/15751d3c669cdd9698a599d6adc6ce88.png" 
              alt="Papi's Paving" 
              className="h-12 sm:h-16 mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Transforming outdoor spaces with quality hardscape solutions for over 15 years.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('home');
                    if (element) {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-green-400 transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('about');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-green-400 transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('services');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-green-400 transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('portfolio');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-green-400 transition-colors text-sm cursor-pointer"
                >
                  Portfolio
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Driveways</li>
              <li>Patios</li>
              <li>Porches</li>
              <li>Walkways</li>
              <li>Retaining Walls</li>
              <li>Backyard Makeovers</li>
              <li>Flower Beds</li>
              <li>Repairs</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <button
                  onClick={scrollToContact}
                  className="flex items-center text-gray-300 hover:text-green-400 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line mr-2 text-purple-400 flex-shrink-0"></i>
                  Contact Us
                </button>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/papispaving?igsh=MTdhOHkxNHB4M2pqdQ%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-300 hover:text-green-400 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line mr-2 text-purple-400 flex-shrink-0"></i>
                  Follow Us on Instagram
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 text-purple-400 mt-1 flex-shrink-0"></i>
                <span>Serving the Greater<br />Metro Area</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              © {currentYear} Papi's Paving. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs sm:text-sm text-gray-400 hover:text-green-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}